<template>
  <div>
    <div class="justify-content-between align-items-center d-flex">
      <h3>
        <feather-icon size="22" icon="FileTextIcon" />
        وثائق المنظمة
      </h3>
    </div>
    <hr />
    <b-row>
      <b-col v-for="(doc, n) in ngoDocs" :key="n" cols="4">
        <div class="info-card px-2 py-1 my-1"  v-if="doc.key === `institution's banking notice` && ngoData.legalForm.id == 1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ doc.label }}
            </div>
            <div>
              <input
                accept="application/pdf"
                type="file"
                :ref="doc.key"
                class="removed"
                @input="uploadDoc(doc.key, $event)"
              />
              <b-button
                :disabled="!ngoData.docs.find((el) => el.filename === doc.key)"
                @mousedown="
                  setDocView(
                    ngoData.docs.find((el) => el.filename === doc.key).source,
                    doc.label
                  )
                "
                variant="flat-info"
                v-b-toggle.doc-view
                class="btn-icon mx-25"
                v-b-tooltip.hover.v-info.bottom
                title="عرض المستند المرفوع"
                v-can="{ slug: $route.meta.slug, action: 'S' }"
              >
                <feather-icon icon="EyeIcon"
              /></b-button>
              <b-button
                @click="$refs[doc.key][0].click()"
                variant="flat-success"
                class="btn-icon"
                v-b-tooltip.hover.v-success.bottom
                :title="loading ? 'جارٍ رفع المستند ...' : 'رفع ملف جديد'"
                :disabled="loading"
                v-if="canUpdateCriticalInfo || (doc.is_required == 0)"
                v-can="{ slug: $route.meta.slug, action: 'O' }"
              >
                <feather-icon icon="UploadIcon"
              /></b-button>
              <b-button
                @click="onDeletedoc(doc)"
                variant="flat-danger"
                class="btn-icon"
                v-b-tooltip.hover.v-danger.bottom
                :title="deletingDoc ? 'جارٍ حذف المستند ...' : 'حذف'"
                :disabled="
                  deletingDoc ||
                  !ngoData.docs.find((el) => el.filename === doc.key)
                "
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                v-if="canUpdateCriticalInfo || (doc.is_required == 0)"
              >
                <feather-icon icon="Trash2Icon"
              /></b-button>
            </div>
          </div>
          <div>
            <hr />
            
            <small class="text-muted d-block"
              >حجم الملف يجب ألاّ يتجاوز 5 ميغا </small
            >
          </div>
        </div>
        <div class="info-card px-2 py-1 my-1" v-else-if="doc.key !== `institution's banking notice`">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ doc.label }}
            </div>
            <div>
              <input
                accept="application/pdf"
                type="file"
                :ref="doc.key"
                class="removed"
                @input="uploadDoc(doc.key, $event)"
              />
              <b-button
                :disabled="!ngoData.docs.find((el) => el.filename === doc.key)"
                @mousedown="
                  setDocView(
                    ngoData.docs.find((el) => el.filename === doc.key).source,
                    doc.label
                  )
                "
                variant="flat-info"
                v-b-toggle.doc-view
                class="btn-icon mx-25"
                v-b-tooltip.hover.v-info.bottom
                title="عرض المستند المرفوع"
                v-can="{ slug: $route.meta.slug, action: 'S' }"
              >
                <feather-icon icon="EyeIcon"
              /></b-button>
              <b-button
                @click="$refs[doc.key][0].click()"
                variant="flat-success"
                class="btn-icon"
                v-b-tooltip.hover.v-success.bottom
                :title="loading ? 'جارٍ رفع المستند ...' : 'رفع ملف جديد'"
                :disabled="loading"
                v-if="canUpdateCriticalInfo || (doc.is_required == 0)"
                v-can="{ slug: $route.meta.slug, action: 'O' }"
              >
                <feather-icon icon="UploadIcon"
              /></b-button>
              <b-button
                @click="onDeletedoc(doc)"
                variant="flat-danger"
                class="btn-icon"
                v-b-tooltip.hover.v-danger.bottom
                :title="deletingDoc ? 'جارٍ حذف المستند ...' : 'حذف'"
                :disabled="
                  deletingDoc ||
                  !ngoData.docs.find((el) => el.filename === doc.key)
                "
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                v-if="canUpdateCriticalInfo || (doc.is_required == 0)"
              >
                <feather-icon icon="Trash2Icon"
              /></b-button>
            </div>
          </div>
          <div>
            <hr />
            
            <small class="text-muted d-block"
              >حجم الملف يجب ألاّ يتجاوز 5 ميغا </small
            >
          </div>
        </div>
      </b-col>
    </b-row>
    <b-sidebar
      right
      width="700px"
      shadow
      bg-variant="white"
      backdrop
      id="doc-view"
    >
      <div class="h-100 p-1 text-center">
        <h4>{{ fileName }}.pdf</h4>
        <hr />
        <FileViewer style="height: 90%" :fileEp="iframeSrc" />
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import FormModal from "@/components/FormModal.vue";
import InfoCard from "@/components/InfoCard.vue";
import FileViewer from "@/components/file-viewer";
import ToastificationContent from "@/@core/components/toastification/ToastificationContent.vue";
import {
  BRow,
  BCol,
  BButton,
  BSpinner,
  BSidebar,
  VBToggle,
  VBTooltip,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    BRow,
    BCol,
    BButton,
    InfoCard,
    FormModal,
    BSpinner,
    BSidebar,
    FileViewer,
  },

  data() {
    return {
      iframeSrc: "",
      fileName: "",

      ngoDocs: [
        {
          label: "نموذج النظام الداخلي/الأساسي",
          key: "internal_system_file",
          is_required : '1'
        },
        {
          label: "قرار الإشهار",
          key: "decision_file",
          is_required : '1'
        },
        {
          label: "محضر توزيع المناصب الإدارية",
          key: "meeting_minutes_of_distribution_of_administrative_positions",
          is_required : '0'
        },
        {
          label: "قرار النفع العام",
          key: "public_benefit_file",
          is_required : '0'
        },
        {
          label: "سند التأسيس",
          key: "proof_of_headquarters",
          is_required : '0'
        },
        {
          label: "الإشعار المصرفي",
          key: "institution's banking notice",
          is_required : '0'
        },
      ],
    };
  },
  methods: {
    ...mapActions("NgoProfile/NgoInfo", ["editNgoData", "deleteDoc"]),
    setDocView(file, fileName) {
      this.iframeSrc = file;
      this.fileName = fileName;
    },
    onDeletedoc(doc) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المستند ؟", {
          title: "تأكيد حذف المستند ",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.deleteDoc(doc)
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تم الحذف بنجاح",
                    icon: "CheckSquareIcon",
                    variant: "success",
                    timeout: 3000,
                  },
                });
              })
              .catch((err) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "حدث خطأ أثناء الحذف !",
                    icon: "XIcon",
                    variant: "danger",
                    timeout: 3000,
                  },
                });
              });
          }
        });
    },
    uploadDoc(docKey, e) {
      var form = new FormData();
      form.append(docKey, e.target.files[0]);
      this.editNgoData(form);
    },
  },
  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
  computed: {
    ...mapGetters("NgoProfile/NgoInfo", ["loading", "deletingDoc"]),
    ...mapGetters("NgoProfile", ["ngoData", "canUpdateCriticalInfo"]),
  },
};
</script>
